// @flow
import React from 'react';
import type {Node} from 'react';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';
import {SessionDocumentListV1} from './SessionDocumentListV1';
import {SessionDocumentListV2} from './SessionDocumentListV2';

type PropsType = {
  columnNames: Array<string>,
  defaultParams?: {[string]: mixed},
  description?: string,
  showProgramFilter?: boolean,
  showMemberFilter?: boolean,
  showStaffFilter?: boolean,
  showGridHeader?: boolean,
  rowHeight?: () => number,
  showDocumentCount?: boolean,
  title?: string,
};

// documentation_v2 switches the whole list implementation: the V2 list uses the
// V2 API (useQuery + server-paginated DataGrid with client-side member/staff
// resolution); the V1 list uses the legacy REST PagedDataGrid. Remove this switch
// (and SessionDocumentListV1) when the flag is retired.
export const SessionDocumentList = (props: PropsType): Node => {
  const documentationV2 = useFeatureFlag(LD_FLAGS.DOCUMENTATION_V2);

  return documentationV2 ? (
    <SessionDocumentListV2 {...props} />
  ) : (
    <SessionDocumentListV1 {...props} />
  );
};
